module.exports = __webpack_public_path__ + "img/x_pattern_mobile.d4ecf875.png";